import { MutableRefObject } from 'react';
import { Socket } from 'socket.io-client';

const useUnbindEvents = () => {
  const events = [
    'Update Viewer',
    'Update Model Error',
    'Update Model Download',
    'realTimeLogging',
    'Update Model Quote Download',
    'Update Model Result Download',
  ];

  const response = (socketRef: MutableRefObject<Socket | undefined>) =>
    events.forEach((event) => {
      socketRef?.current?.off(event);
    });

  return [response];
};

export { useUnbindEvents };
